module.exports = __webpack_public_path__ + "static/img/2.0e613758.jpg";